import React, { useState, useCallback } from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

export default function PasswordField(props) {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const handleClickEyeIcon = useCallback(() => {
    setIsShowPassword(!isShowPassword);
  }, [isShowPassword]);

  return (
    <TextField
      type={isShowPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleClickEyeIcon}>
              {isShowPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}
